/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiBatchJobDtoBatchJobDto,
  WebApiBatchJobDtoBatchJobStatusDto,
  WebApiBatchJobDtoUpdateBatchJobDto,
} from '../models';
import {
    WebApiBatchJobDtoBatchJobDtoFromJSON,
    WebApiBatchJobDtoBatchJobDtoToJSON,
    WebApiBatchJobDtoBatchJobStatusDtoFromJSON,
    WebApiBatchJobDtoBatchJobStatusDtoToJSON,
    WebApiBatchJobDtoUpdateBatchJobDtoFromJSON,
    WebApiBatchJobDtoUpdateBatchJobDtoToJSON,
} from '../models';

export interface ApiBatchJobGetBatchJobIdGetRequest {
    batchJobId: number;
}

export interface ApiBatchJobGetStatusBatchJobIdGetRequest {
    batchJobId: number;
}

export interface ApiBatchJobUpdatePutRequest {
    webApiBatchJobDtoUpdateBatchJobDto?: WebApiBatchJobDtoUpdateBatchJobDto;
}

/**
 * 
 */
export class BatchJobApi extends runtime.BaseAPI {

    /**
     * Gets a batch job by identifier.
     */
    async apiBatchJobGetBatchJobIdGetRaw(requestParameters: ApiBatchJobGetBatchJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiBatchJobDtoBatchJobDto>> {
        if (requestParameters.batchJobId === null || requestParameters.batchJobId === undefined) {
            throw new runtime.RequiredError('batchJobId','Required parameter requestParameters.batchJobId was null or undefined when calling apiBatchJobGetBatchJobIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BatchJob/Get/{batchJobId}`.replace(`{${"batchJobId"}}`, encodeURIComponent(String(requestParameters.batchJobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiBatchJobDtoBatchJobDtoFromJSON(jsonValue));
    }

    /**
     * Gets a batch job by identifier.
     */
    async apiBatchJobGetBatchJobIdGet(requestParameters: ApiBatchJobGetBatchJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiBatchJobDtoBatchJobDto> {
        const response = await this.apiBatchJobGetBatchJobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all batch jobs for the current company with status information.
     */
    async apiBatchJobGetHistoryGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiBatchJobDtoBatchJobStatusDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BatchJob/GetHistory`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiBatchJobDtoBatchJobStatusDtoFromJSON));
    }

    /**
     * Gets all batch jobs for the current company with status information.
     */
    async apiBatchJobGetHistoryGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiBatchJobDtoBatchJobStatusDto>> {
        const response = await this.apiBatchJobGetHistoryGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the status of a batch job with progress information.
     */
    async apiBatchJobGetStatusBatchJobIdGetRaw(requestParameters: ApiBatchJobGetStatusBatchJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiBatchJobDtoBatchJobStatusDto>> {
        if (requestParameters.batchJobId === null || requestParameters.batchJobId === undefined) {
            throw new runtime.RequiredError('batchJobId','Required parameter requestParameters.batchJobId was null or undefined when calling apiBatchJobGetStatusBatchJobIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BatchJob/GetStatus/{batchJobId}`.replace(`{${"batchJobId"}}`, encodeURIComponent(String(requestParameters.batchJobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiBatchJobDtoBatchJobStatusDtoFromJSON(jsonValue));
    }

    /**
     * Gets the status of a batch job with progress information.
     */
    async apiBatchJobGetStatusBatchJobIdGet(requestParameters: ApiBatchJobGetStatusBatchJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiBatchJobDtoBatchJobStatusDto> {
        const response = await this.apiBatchJobGetStatusBatchJobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing batch job.
     */
    async apiBatchJobUpdatePutRaw(requestParameters: ApiBatchJobUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BatchJob/Update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiBatchJobDtoUpdateBatchJobDtoToJSON(requestParameters.webApiBatchJobDtoUpdateBatchJobDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Updates an existing batch job.
     */
    async apiBatchJobUpdatePut(requestParameters: ApiBatchJobUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiBatchJobUpdatePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
